import {FormEvent, useCallback, useState} from "react";
import {Config} from "../components/config";
import {Footer} from "../components/modules/Footer/Footer";
import Head from "next/head";
import {Loader} from "../components/common/Loader/Loader";
import {Modal} from "../components/common/Modal/Modal";
import {Navbar} from "../components/modules/Navbar/Navbar";
import type {NextPage} from "next";
import {TickIcon} from "../components/common/Icon/TickIcon/TickIcon";
import {browserName, browserVersion, isMacOs, isMobile, isWindows} from "react-device-detect";
import {useReCaptcha} from "next-recaptcha-v3";

const Page: NextPage = () => {
    const [isBusy, setIsBusy] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const openSuccessModal = () => setModalOpen(true);
    const closeSuccessModal = () => setModalOpen(false);
    const closeErrorModal = () => setErrorModalOpen(false);
    const openErrorModal = () => setErrorModalOpen(true);

    const {
        executeRecaptcha,
        /** reCAPTCHA_site_key */
        reCaptchaKey,
        /** Global ReCaptcha object */
        grecaptcha,
        /** Is ReCaptcha script loaded */
        loaded,
        /** Is ReCaptcha script failed to load */
        error,
        /** Other hook props */
        ...otherProps
    } = useReCaptcha();


    const handleSubmit = useCallback(
        async (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault();

            try {
                // Generate ReCaptcha token
                const token = await executeRecaptcha("contactForm");

                handleSubmitForm(e, token);
            } catch (e) {
                console.log(e);
            }
        },
        [executeRecaptcha],
    );

    const handleSubmitForm = async (e: FormEvent<HTMLFormElement>, token: string) => {

        // e.preventDefault();

        if (isBusy) {
            return;
        }


        const form = e.target as HTMLFormElement;
        const formData = new FormData(form);

        const email = formData.get("email")?.toString() ?? "";
        const name = formData.get("name")?.toString() ?? "";
        const description = formData.get("description")?.toString() ?? "";

        if (!email.length || !name.length) {
            alert("please fill in the values correctly");
            return;
        }

        var message = `Name: ${name}\n` + `Description: ${description}`;
        message += `\n\nBrowserInfo: ${window.navigator.userAgent}`;
        message += `
    \n\nbrowserName: ${browserName}
    \nbrowserVersion: ${browserVersion}
    \nisMobile: ${isMobile}
    \nisMacOs: ${isMacOs}
    \nisWindows: ${isWindows}
    `;

        const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                email: email,
                message: message,
                token: token,
            }),

        };
        try {
            setIsBusy(true);
            const res = await fetch("/api/send_mail", requestOptions);

            if (res.status == 200) {
                openSuccessModal();
                resetForm(form);
            } else {
                openErrorModal();
            }
            setIsBusy(false);
            //   console.log(await res.json());
        } catch (e) {
            console.log(e);
            openErrorModal();
            setIsBusy(false);
        }
    };

    const resetForm = (form: HTMLFormElement) => {
        const elements = form.elements as any;
        if (elements["name"]) {
            elements["name"].value = "";
        }

        if (elements["email"]) {
            elements["email"].value = "";
        }

        if (elements["description"]) {
            elements["description"].value = "";
        }
    };

    return (
        <div className="">

                <Head>
                    <title>Contact Us - {Config.appNameShort}</title>
                    <link rel="canonical" href="https://www.photojoiner.com/contact-us"/>
                </Head>
                <Navbar backgroundColor="white"/>
                <div className="flex flex-col lg:px-52 px-4 pt-32 gap-8">
                    {/* <div
                    className="pt-16 rounded-md"
                    style={{ backgroundColor: "#F09AD8" }}
                >
                    <ContactUsImage />
                </div> */}
                    <form
                        id="contact-form"
                        className="flex flex-col xl:flex-row gap-4 xl:gap-24 mt-12 mb-24"
                        onSubmit={handleSubmit}
                    >
                        <div className="text-4xl xl:text-6xl whitespace-nowrap">
                            Contact Us
                        </div>
                        <div className="flex flex-col gap-8 p-8 w-full bg-white rounded-md box-shadow">
                            <label className="text-dark-gray" htmlFor="name">
                                Full Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="outline-none border-b border-b-light-gray pb-4 text-gray"
                                placeholder="John Doe"
                            />

                            <label className="text-dark-gray" htmlFor="email">
                                Email
                            </label>
                            <input
                                type="email"
                                name="email"
                                className="outline-none border-b border-b-light-gray pb-4 text-gray"
                                placeholder="example@email.com"
                            />

                            <label className="text-dark-gray" htmlFor="description">
                                Description
                            </label>

                            <textarea
                                name="description"
                                className="outline-none pb-4 text-gray resize-none h-60 w-full p-8 bg-extra-light-gray rounded-md"
                                placeholder="Write your message here..."
                            />

                            <div className="flex items-center justify-between">
                                <div>{/* <AttachIcon /> */}</div>
                                <div className="flex items-center gap-8">
                                    {/* <div className="cursor-pointer">Cancel</div> */}
                                    <button
                                        type="submit"
                                        className={`${isBusy ? " cursor-wait" : "cursor-pointer "} ${" flex flex-row items-center justify-center text-white bg-orange px-8 py-2 rounded-l-full rounded-r-full"}`}
                                    >
                                        <div className={`${isBusy ? "" : " hidden"} ${" inline-block pr-2"}`}><Loader
                                            width={18} height={18}/></div>
                                        Send
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <Footer backgroundColor="#FAFAFA" textColor="black" titleColor="black"/>

                {/* Success Modal */}
                <Modal isOpen={modalOpen} close={closeSuccessModal}>
                    <div
                        className="flex items-center justify-center h-screen select-none"
                        onClick={closeSuccessModal}
                    >
                        <div
                            className="flex flex-col gap-8 items-center bg-white p-8 xl:p-10 rounded-xl"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex flex-col lg:flex-row gap-8 items-center ">
                                <div className="bg-green rounded-full p-4">
                                    <TickIcon/>
                                </div>
                                <div className="text-xl text-center">
                                    We have got your response!
                                </div>
                            </div>
                            <div className="w-full flex flex-col items-end justify-end ">
                                <button
                                    className="cursor-pointer text-white bg-orange px-8 py-2 rounded-l-full rounded-r-full"
                                    onClick={closeSuccessModal}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                {/* Failed Modal */}
                <Modal isOpen={errorModalOpen} close={closeErrorModal}>
                    <div
                        className="flex items-center justify-center h-screen select-none"
                        onClick={closeErrorModal}
                    >
                        <div
                            className="flex flex-col gap-8 items-center bg-white p-8 xl:p-10 rounded-xl"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex flex-col lg:flex-row gap-8 items-center ">
                                {/* <div className="bg-green rounded-full p-4">
                            <TickIcon />
                        </div> */}
                                <div className="text-xl text-center">
                                    Failed to send your feedback!
                                </div>
                            </div>
                            <div className="w-full flex flex-col items-end justify-end ">
                                <button
                                    className="cursor-pointer text-white bg-orange px-8 py-2 rounded-l-full rounded-r-full"
                                    onClick={closeErrorModal}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

        </div>
    );
};

export default Page;
